import React, { useState, useEffect } from 'react'
import { SettleScaniaPrint } from "@/components/SettleScaniaPrint"
import { repairFormatNum, numberParseChina, momentFormat } from '@/utils/utils';
import { maintenanceService } from '../../maintenanceService';
import { useMaintenanceModel } from '../maintenanceModel';
import { IMaintenanceDetail, IMaterialDetailList, IItemDetailList } from '../../maintenanceType';
import moment from 'moment';
import useGlobalModel from '@/model/globalModel';
export const SettleScaniaPrints = ({
}) => {
    // settleScaniaPrint, setSettleScaniaPrint
    const { shopAndOrg: { shopCode, shopName } } = useGlobalModel()

    const { settleScaniaPrint: visible, selectedRow, setSettleScaniaPrint } = useMaintenanceModel()
    const onClose = () => {
        setSettleScaniaPrint(false)
    }
    const print = () => {

    }
    const [formVal, setFormVal] = useState<IMaintenanceDetail>({});
    const [maintenanceList, setMaintenanceList] = useState<IMaterialDetailList[]>([]);
    const [itemList, setItemList] = useState<IItemDetailList[]>([]);
    useEffect(() => {
        visible && getDetailOne()
    }, [visible])
    const getDetailOne = async () => {
        let { retData } = await maintenanceService.one(selectedRow.maintenanceCode as string);
        let { itemDetails, materialDetails, receivableTotalAmount, enterTime, deliveryTime, workingHoursAmount, materialScienceAmount, discountTotalAmount, totalAmount, ...from } = retData
        receivableTotalAmount = from.serviceNatureCode === "repair-type.maintain" || from.serviceNatureCode === "repair-type.claim" ? 0 : repairFormatNum(receivableTotalAmount)
        workingHoursAmount = from.serviceNatureCode === "repair-type.maintain" || from.serviceNatureCode === "repair-type.claim" ? 0 : workingHoursAmount
        materialScienceAmount = from.serviceNatureCode === "repair-type.maintain" || from.serviceNatureCode === "repair-type.claim" ? 0 : materialScienceAmount
        discountTotalAmount = from.serviceNatureCode === "repair-type.maintain" || from.serviceNatureCode === "repair-type.claim" ? 0 : discountTotalAmount
        totalAmount = from.serviceNatureCode === "repair-type.maintain" || from.serviceNatureCode === "repair-type.claim" ? 0 : totalAmount
        const newItemDetails = itemDetails?.map((item, index) => {
            return {
                ...item,
                No: index + 1
            }
        })
        const newMaterialDetails = materialDetails?.map((item, index) => {
            return {
                ...item,
                No: index + 1
            }
        })
        if (retData) {
            setMaintenanceList(newMaterialDetails as IMaterialDetailList[] ?? []);
            setItemList(newItemDetails as IItemDetailList[] ?? []);
            console.log(
                receivableTotalAmount,
                workingHoursAmount,
                materialScienceAmount,
                discountTotalAmount,
                totalAmount,
            )
            setFormVal({
                ...from,
                receivableTotalAmount,
                workingHoursAmount,
                materialScienceAmount,
                discountTotalAmount,
                totalAmount,
                receivableTotalAmountCN: numberParseChina(receivableTotalAmount),
                enterTime: momentFormat(enterTime),
                deliveryTime: momentFormat(deliveryTime)
            })
        }
    }
    const itemClumns = [
        {
            title: '序号',
            dataIndex: 'No',
        },
        {
            title: '项目编号',
            dataIndex: 'itemCode',
        },
        {
            title: '项目名称',
            dataIndex: 'itemName',
        },
        {
            title: '工时',
            dataIndex: 'workHour',
            // render: (text: any) =>  formVal.serviceNatureCode === "repair-type.maintain" || formVal.serviceNatureCode === "repair-type.claim" ? 0 : text
        },
        {
            title: '单价',
            dataIndex: 'price',
            render: (text: any) => formVal.serviceNatureCode === "repair-type.maintain" || formVal.serviceNatureCode === "repair-type.claim" ? 0 : text
        },
        {
            title: '折扣',
            dataIndex: 'discountRate',
            render: (text: any) => formVal.serviceNatureCode === "repair-type.maintain" || formVal.serviceNatureCode === "repair-type.claim" ? "100%" : text + "%"
        },
        {
            title: '工时费',
            dataIndex: 'receivableAmount',
            render: (text: any) => formVal.serviceNatureCode === "repair-type.maintain" || formVal.serviceNatureCode === "repair-type.claim" ? 0 : text
        },
        {
            title: '备注',
            dataIndex: 'note',
            colSpan: 2
        },
    ]
    const columns = [
        {
            title: '序号',
            dataIndex: 'No',
        },
        {
            title: '材料编号',
            dataIndex: 'materialCode',
        },
        {
            title: '材料名称',
            dataIndex: 'materialName',
        },
        {
            title: '数量',
            dataIndex: 'num',
            // render: (text: any) =>  formVal.serviceNatureCode === "repair-type.maintain" || formVal.serviceNatureCode === "repair-type.claim" ? 0 : text
        },
        {
            title: '单价',
            dataIndex: 'price',
            render: (text: any) => formVal.serviceNatureCode === "repair-type.maintain" || formVal.serviceNatureCode === "repair-type.claim" ? 0 : text
        },
        {
            title: '折扣',
            dataIndex: 'discountRate',
            render: (text: any) => formVal.serviceNatureCode === "repair-type.maintain" || formVal.serviceNatureCode === "repair-type.claim" ? "100%" : text + "%"
        },
        {
            title: '金额',
            dataIndex: 'receivableAmount',
            render: (text: any) => formVal.serviceNatureCode === "repair-type.maintain" || formVal.serviceNatureCode === "repair-type.claim" ? 0 : text
        },
        {
            title: '单位',
            dataIndex: 'unitName',
        },
        {
            title: '备注',
            dataIndex: 'note',
        },
    ]
    let IHeader = [
        {
            fieldLabel: "工号：",
            fieldValue: formVal.maintenanceCode
        }, {
            fieldLabel: "支付方式：",
            fieldValue: formVal.paymentMethodName
        }, {
            fieldLabel: "打印日期：",
            fieldValue: moment(new Date()).format("YYYY-MM-DD HH:mm")
        },
    ]
    return <SettleScaniaPrint
        title={`${shopName}`}
        visible={visible}
        onClose={onClose}
        columns={columns}
        itemClumns={itemClumns}
        itemDataSource={itemList}
        dataSource={maintenanceList.filter(item => item.num !== 0)}
        formVal={formVal}
        shopCode={shopCode}
        isTechnician={true}
    />
}